import { FAQ, Message } from "@/types/chatbot"
import { systemConfig } from "@/config/site"
import { apiFetch } from "@/lib/utils"

import { getClientId } from "../auth"

export async function fetchFAQs(): Promise<FAQ[]> {
  const clientId = getClientId()

  const res = await apiFetch(
    `himo-assistant/faqs/?client_id=${clientId}&hirayatech_system_id=${systemConfig.hirayaSystemId}`,
  )

  if (!res.ok) {
    throw new Error("Failed to fetch")
  }

  return res.json()
}

export async function saveFAQ(id: string): Promise<FAQ> {
  const res = await apiFetch(`himo-assistant/faqs/${id}/`)

  if (!res.ok) {
    throw new Error("Failed to fetch")
  }

  return res.json()
}

export async function fetchUserConversations(): Promise<Message[]> {
  const res = await apiFetch(
    `himo-assistant/user-conversations/?hirayatech_system_id=${systemConfig.hirayaSystemId}`,
  )

  if (!res.ok) {
    throw new Error("Failed to fetch")
  }

  const data = await res.json()

  return data
    .map(
      (item: {
        question: string
        answer: string
        created_at: string
        updated_at: string
      }) => [
        {
          id: crypto.randomUUID(),
          content: item.question,
          sender: "user",
          created_at: item.created_at,
          updated_at: item.updated_at,
        },
        {
          id: crypto.randomUUID(),
          content: item.answer,
          sender: "bot",
          created_at: item.created_at,
          updated_at: item.updated_at,
        },
      ],
    )
    .flat()
}
